import { IArrowDownIconProps } from "interfaces";

const ArrowDownIcon = ({ className, onClick }: IArrowDownIconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M8.00294 11.2004C7.53628 11.2004 7.06961 11.0204 6.71628 10.6671L2.36961 6.32042C2.17628 6.12708 2.17628 5.80708 2.36961 5.61375C2.56294 5.42042 2.88294 5.42042 3.07628 5.61375L7.42294 9.96042C7.74294 10.2804 8.26294 10.2804 8.58294 9.96042L12.9296 5.61375C13.1229 5.42042 13.4429 5.42042 13.6363 5.61375C13.8296 5.80708 13.8296 6.12708 13.6363 6.32042L9.28961 10.6671C8.93628 11.0204 8.46961 11.2004 8.00294 11.2004Z" />
        </svg>
    );
};

export default ArrowDownIcon;
